// extracted by mini-css-extract-plugin
export default {"row":"InvoiceTable_row__WYuGa","table":"InvoiceTable_table__oTp43"};